/**
 *  微信 API 地址
 *  @swagger  https://tst-bpcentral.lenovo.com.cn/wechat/swagger-ui.html#/%E5%BE%AE%E4%BF%A1%E6%8E%88%E6%9D%83%E7%B1%BB%E6%8E%A5%E5%8F%A3
 */
export class EnumApiWechat {
    constructor() {
        /**
         * @dec 生成jsap权限签名
         */
        this.wechat_jsapi_sign = {
            url: '/api/bpportal/pcsd-bp-customer-bffsvr/wechat/auth/jsapi/sign',
            method: 'post',
            // loading: true
            // cache: true
        };
        /**
         * @dec 获取小程序 openid
         * @body jsCode
         */
        this.wechat_weapp_session = {
            url: '/api/bpportal/bp-customer-wechat-svr/mini/user/session/get',
        };
        /**
         * @dec 获取 openid
         */
        this.wechat_login = {
            url: '/wechat/auth/oauth/login',
            loading: true,
        };
        /**
         * @dec 获取 openid
         */
        this.wechat_info = {
            url: '/wechat/user/info/get',
            loading: true,
        };
        /**
         * @dec 发送模板消息
         */
        this.wechat_send = {
            url: '/wechat/msg/subscribe/send',
            method: 'post',
            loading: true,
        };
    }
}
